import React from 'react'
import Details from 'gatsby-core-theme/src/components/atoms/author-box/details'

export default (props) => {
    return <Details {...props} width={80} height={80} />;
};